const accBtn = document.querySelectorAll('.header__menuTtl')

window.addEventListener("load", () => {
    document.body.classList.add("loaded")
    accBtn.forEach((accBtnList) => {
        const ans = accBtnList.nextElementSibling
        let height = (ans.clientHeight + 1) / window.innerWidth * 100;
        let width = (ans.clientWidth + 1) / window.innerWidth * 100;
        ans.style.height = "0vw"
        ans.style.width = "0vw"

        accBtnList.addEventListener('click', () => {
            openAcc()
        });

        function openAcc() {
            const accBtnParent = accBtnList.parentNode
            accBtnParent.classList.toggle("is-on")

            if (accBtnParent.classList.contains("is-on")) {
                ans.style.height = `${height}vw`
                ans.style.width = `${width}vw`
            } else {
                ans.style.height = "0vw"
                ans.style.width = "0vw"
            }
        }
    });
})

let menutxts = document.querySelectorAll(".header__menuTxtInner>a")

menutxts.forEach((txt) => {
    txt.addEventListener("click", () => {
        document.querySelector(".header__menu").classList.remove("is-on")
        let menutxt = document.querySelector(".header__menuTxt")
        menutxt.style.width = "0vw"
        menutxt.style.height = "0vw"
    })
})